module.exports = __webpack_public_path__ + "img/no3.a437d9c1.svg";